<template>
  <table style="table-layout: fixed; width: 100%">
    <thead style="color: gray;">
      <tr>
        <th></th>
        <td>月</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td>土</td>
        <td>日</td>
      </tr>
    </thead>
    <tbody>
      <tr v-if="!isShowPast && Math.ceil((lastNum + 1) / 7) > 6">
        <td colspan="8">
          <a @click.prevent.stop="isShowPast = true" href="">
            <i class="fas fa-eye"></i>
            過去のまぐわいも表示する
          </a>
        </td>
      </tr>
      <template v-if="mags.length > 0">
        <tr v-for="weekNum in weekNums">
          <th style="color: gray; font-size: x-small;">
            <span v-if="weekNum % 2 === 0 || weekNum === Math.floor(lastNum / 7)">
              {{ day(weekNum, 0) }}
            </span>
          </th>
          <td v-for="(_j, dayNum) in 7"  :class="boxClass(weekNum, dayNum)" :title="title(weekNum, dayNum)">
            &nbsp;
          </td>
        </tr>
      </template>
    </tbody>
  </table>
</template>

<script>
import moment from 'moment'

export default {
  components: {  },
  props: ['mags'],
  data() {
    return { isShowPast: false }
  },
  mounted() {
  },
  methods: {
    boxClass(weekNum, dayNum) {
      const mag = this.magDayByNum[weekNum * 7 + dayNum]
      if (!mag) { return 'none' }
      return mag.count == 1 ? 'one' : 'more'
    },
    title(weekNum, dayNum) {
      const mag = this.magDayByNum[weekNum * 7 + dayNum]
      if (!mag) { return '' }
      return mag.day
    },
    day(weekNum, dayNum) {
      return moment(this.firstDay).add(weekNum * 7 + dayNum, 'day').format('M月D日')
    }
  },
  computed: {
    firstDay() {
      const first = moment(this.mags[this.mags.length - 1].day)
      first.add(1 - first.isoWeekday(), 'days')
      return first
    },
    magDayByNum() {
      const obj = {}
      for(const mag of this.mags) {
        const num = moment(mag.day).diff(this.firstDay, 'day')
        if (obj[num]) {
          obj[num].count = obj[num].count + 1
        } else {
          obj[num] = {
            count: 1,
            day: mag.day
          }
        }
      }
      return obj
    },
    lastNum() {
      return Math.max(...Object.keys(this.magDayByNum))
    },
    weekNums() {
       const weekNumMax = Math.ceil((this.lastNum + 1) / 7)
       const array = []
       let i = this.isShowPast ? 0 : weekNumMax - 6
       i = Math.max(i, 0)
       for (; i < weekNumMax; i++) {
         array.push(i)
       }
       return array
    }
  }
}
</script>

<style scoped>
.one {
  color: #ffa99a;
  background-color: #ffa99a;
}
.more {
  color: tomato;
  background-color: tomato;
}
table, th, td {
  border: 4px solid white;
  text-align: center;
}
th {
  width: 3em;
}
</style>
